import { getFormattedCustomerName } from 'client/components/customers/common/Helpers'
import { DraftInterface } from 'client/Interfaces/Draft/DraftInterface'

export const getCustomerName = (draft: DraftInterface) => {
  if (!draft.receiver.displayName) {
    draft.receiver.displayName = getFormattedCustomerName(draft.receiver, false)
  }
  return draft
}
